import React, {useEffect} from "react";
import { Modal, Form } from "antd";
import { optionLabel } from "../../../utils/Helpers";

const ModalBody = (props) => {
  const [form] = Form.useForm();

  useEffect(()=>{
    form.setFieldsValue(props?.modalOpen?.value)
  },[props?.modalOpen?.value])
  
  return (
    <Modal
      title={optionLabel(props?.modalOpen?.type)}
      visible={props?.modalOpen?.modal}
      okText={`Confirm ${optionLabel(props?.modalOpen?.type)}`}
      confirmLoading={props.Loading}
      cancelText="Cancel"
      onCancel={()=>props?.modalCancel()}
      onOk={() => {form.validateFields().then((values) => {
        // form.resetFields();
        props?.onCreateAction(values, props?.modalOpen);
      })}}
    >
      <Form form={form} layout="vertical" initialValues={{ modifier: 'public', }}>
        {props?.modalOpen?.formBody === null ? <></> : props?.modalOpen?.formBody}
      </Form>
    </Modal>
  );
};
export default ModalBody;
